
const digest = '2ad83ef50cdd0f9f995969941c3d2ea6e0de8988b790aed9ec3cf8b7e6ade97f';
const classes = {"container":"_container_1b36d_1","content":"_content_1b36d_7","toothWrapper":"_toothWrapper_1b36d_12"};
const css = `._container_1b36d_1 {
  display: flex;
  height: 100%;
  position: relative;
}

._content_1b36d_7 {
  flex: 1;
  padding-left: 20px;
}

._toothWrapper_1b36d_12 {
  min-width: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
  border-right: 1px solid #e2e5ed;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  